import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Loadable from "react-loadable";

import appRoutes from "./appRoutes";

import { checkUserAccess, saveUrlParams } from "../reduxStore/actions/auth";

import Loader from "../components/loader";

import PDFDownload from "../pages/PDFDownload"

// import { useCheckActivity } from "../utils/useCheckActivity";
// import CustomModal from "../components/modal";
// import ReAuthenticate from "../components/form/reAuthenticate";
// import { setIsReAuthenticationRequired } from "../reduxStore/actions/auth";

const DashboardLayout = Loadable({
  loader: () => import("../containers/Layout/Dashboard"),
  loading() {
    return <div />;
  }
});

const TemplateLayout = Loadable({
  loader: () => import("../containers/Layout/Template"),
  loading() {
    return <div />;
  }
});
const PatientRecordHeader = Loadable({
  loader: () => import("../pages/PatientRecordHeader/PatientRecordHeader"),
  loading() {
    return <div />;
  }
});
const NotAuthorizedPage = Loadable({
  loader: () => import("../pages/NotAuthorized"),
  loading() {
    return <Loader />;
  }
});
const PatientDetails = Loadable({
  loader: () => import("../pages/Details/PatientDetails"),
  loading() {
    return <Loader />;
  }
});
const ConsultNotes = Loadable({
  loader: () => import("../pages/ConsultNotes/ConsultNotes"),
  loading() {
    return <div />;
  }
});
const MedicalInfo = Loadable({
  loader: () => import("../pages/MedicalInfo/MedicalInfo"),
  loading() {
    return <div />;
  }
});
const AccessLogs = Loadable({
  loader: () => import("../pages/AccessLog/AccessLog"),
  loading() {
    return <div />;
  }
});
const MedicalCertificate = Loadable({
  loader: () => import("../pages/Template/MedicalCertificate"),
  loading() {
    return <Loader />;
  }
});
const CarerMedicalCertificate = Loadable({
  loader: () => import("../pages/Template/CarerCertificate"),
  loading() {
    return <Loader />;
  }
});
const Prescription = Loadable({
  loader: () => import("../pages/Template/Prescription"),
  loading() {
    return <Loader />;
  }
});
const ReferralLetter = Loadable({
  loader: () => import("../pages/Template/ReferralLetter"),
  loading() {
    return <Loader />;
  }
});
const PathologyRequest = Loadable({
  loader: () => import("../pages/Template/PathologyRequest"),
  loading() {
    return <Loader />;
  }
});
const RadiologyRequst = Loadable({
  loader: () => import("../pages/Template/RadiologyRequest"),
  loading() {
    return <Loader />;
  }
});
const GeneralLetter = Loadable({
  loader: () => import("../pages/Template/GeneralLetter"),
  loading() {
    return <Loader />;
  }
});
const CosmeticInjectables = Loadable({
  loader: () => import("../pages/Template/CosmeticInjectables"),
  loading() {
    return <Loader />;
  }
});
const IntravenousTherapy = Loadable({
  loader: () => import("../pages/Template/IntravenousTherapy"),
  loading() {
    return <Loader />;
  }
});

// we will use this components for the restricted routes which can be accessed after login only
const RestrictedRoute = props => (
  <Fragment>
    {props.haveAccess === true ? (
      <Route exact path={props.path} component={props.component} />
    ) : (
      <Redirect to={appRoutes.notAuthorized} from={props.path} />
    )}
  </Fragment>
);

// We will use this component for public routes which cannot be access after login
const PublicRoute = props => (
  <Fragment>
    {props.haveAccess === false ? (
      <Route exact path={props.path} component={props.component} />
    ) : (
      <Redirect to={appRoutes.patientDetails} from={props.path} />
    )}
  </Fragment>
);

const AppRoutes = props => {
  const queryString = window ? window.location.search : "";
  let urlParams = new URLSearchParams(queryString);
  let accessToken = urlParams.get("accessToken");

  // // if user is not active, generate a dialog to ask for re-authentication
  // const [isActive, resetCheckActivity] = useCheckActivity(1000 * 60 * 100);

  // useEffect(() => {
  //   if (!isActive) {
  //     props.setIsReAuthenticationRequired(true);
  //   }
  // }, [isActive]);

  const checkUserAccess = async () => {
    if (accessToken !== undefined && accessToken !== null) {
      await props.checkUserAccess(accessToken);
      // save the query params
      let urlprm = {
        accessToken: urlParams.get("accessToken"),
        patientId: urlParams.get("patientId"),
        searchType: urlParams.get("searchType"),
        adminName: urlParams.get("adminName")
      };

      await props.saveUrlParams(urlprm);
    } else {
      await props.checkUserAccess(
        props.auth && props.auth.data ? props.auth.data.accessToken : ""
      );
      // save the query params
      let urlprm = {
        accessToken: "",
        patientId: "",
        searchType: "",
        adminName: ""
      };

      await props.saveUrlParams(
        props.auth && props.auth.urlParams ? props.auth.urlParams : urlprm
      );
    }
  };

  useEffect(() => {
    checkUserAccess();
  }, []);

  // useEffect(() => {
  //   DashboardLayout.preload();
  //   TemplateLayout.preload();
  //   PatientRecordHeader.preload();
  //   NotAuthorizedPage.preload();
  //   PatientDetails.preload();
  //   ConsultNotes.preload();
  //   MedicalInfo.preload();
  //   AccessLogs.preload();
  //   MedicalCertificate.preload();
  //   Prescription.preload();
  //   ReferralLetter.preload();
  //   PathologyRequest.preload();
  //   RadiologyRequst.preload();
  //   GeneralLetter.preload();
  //   CosmeticInjectables.preload();
  //   IntravenousTherapy.preload();
  // });

  const auth = props.auth;
  return (
    <div>
      {/* 
      <CustomModal
        className="modal-md text-center"
        openModal={props.auth.isReAuthenticationRequired}
        title="Please enter Password again due to long inactive period"
        noFooterButtons={true}
        modalBodyContent={
          <ReAuthenticate
            successfulCallback={() => {
              props.setIsReAuthenticationRequired(false);
              resetCheckActivity();
            }}
          />
        }
      />
 */}
      <Router>
        <Switch>
          <Redirect exact from="/" to={appRoutes.patientDetails} />
          <PublicRoute
            path={appRoutes.notAuthorized}
            component={NotAuthorizedPage}
            haveAccess={auth.haveAccess}
          />
          <Route path="/patient">
            <Switch>
              <DashboardLayout>
                <PatientRecordHeader>
                  <Route
                    exact
                    path={appRoutes.patientDetails}
                    component={PatientDetails}
                  />
                  <RestrictedRoute
                    path={appRoutes.consultNotes}
                    component={ConsultNotes}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.medicalInfo}
                    component={MedicalInfo}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.accessLogs}
                    component={AccessLogs}
                    haveAccess={auth.haveAccess}
                  />
                </PatientRecordHeader>
              </DashboardLayout>
            </Switch>
          </Route>
          <Route path="/templates">
            <Switch>
              <DashboardLayout>
                <TemplateLayout>
                  <RestrictedRoute
                    path={appRoutes.tempMedicalCertificate}
                    component={MedicalCertificate}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.carerMedicalCertificate}
                    component={CarerMedicalCertificate}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempPrescription}
                    component={Prescription}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempReferralLetter}
                    component={ReferralLetter}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempPathologyRequest}
                    component={PathologyRequest}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempRadiologyRequest}
                    component={RadiologyRequst}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempGeneralLetter}
                    component={GeneralLetter}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempCosmeticInjectables}
                    component={CosmeticInjectables}
                    haveAccess={auth.haveAccess}
                  />
                  <RestrictedRoute
                    path={appRoutes.tempIntravenousTherapy}
                    component={IntravenousTherapy}
                    haveAccess={auth.haveAccess}
                  />
                </TemplateLayout>
              </DashboardLayout>
            </Switch>
          </Route>
          <Route path="/pdf">
            <Switch>
              <DashboardLayout>
                  <Route
                    exact
                    path={appRoutes.generatePDF}
                    component={PDFDownload}
                  />
              
              </DashboardLayout>
            </Switch>
          </Route>
        
          <Redirect from="*" to="/404" />
        </Switch>
      </Router>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  checkUserAccess: data => dispatch(checkUserAccess(data)),
  saveUrlParams: data => dispatch(saveUrlParams(data))
  // setIsReAuthenticationRequired: data =>
  //   dispatch(setIsReAuthenticationRequired(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
